import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import CoursePageTemplate, { CoursePageTemplateProps } from './template';

const CoursePage: React.FC<CoursePageTemplateProps> = ({ course, popularCourses }) => {
  const { meta } = course;

  const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || 'http://localhost:3000';

  const SEO = {
    title: `Curso - ${meta?.metaTitle || course.title}`,
    description: meta?.metaDescription || course.shortDescription || '',
    openGraph: {
      type: 'website',
      locale: 'pt',
      url: `${siteUrl}/cursos/${course.slug}`,
      ['site_name']: 'App Masters Academy',
      images: [
        {
          url: meta?.metaImage?.url || course.image?.url || '',
          width: 800,
          height: 600,
        },
      ],
    },
  };

  const itemListElements = [
    {
      position: 1,
      name: 'App Masters Academy',
      item: siteUrl,
    },
    {
      position: 2,
      name: 'Cursos',
      item: `${siteUrl}/cursos`,
    },
    {
      position: 3,
      name: meta?.metaTitle || '',
      item: `${siteUrl}/cursos/${course.slug}`,
    },
  ];

  const { asPath } = useRouter();

  return (
    <>
      <NextSeo {...SEO} />
      <BreadcrumbJsonLd itemListElements={itemListElements} />
      <CoursePageTemplate
        course={course}
        popularCourses={popularCourses}
        url={siteUrl + '/' + asPath}
      />
    </>
  );
};

export default CoursePage;
